var map = {
	"./template.bet575": 1582,
	"./template.bet575.tsx": 1582,
	"./template.bet777": 1583,
	"./template.bet777.tsx": 1583,
	"./template.betgalaxy": 1584,
	"./template.betgalaxy.tsx": 1584,
	"./template.betprofessor": 1585,
	"./template.betprofessor.tsx": 1585,
	"./template.betroyale": 1586,
	"./template.betroyale.tsx": 1586,
	"./template.betstride": 1587,
	"./template.betstride.tsx": 1587,
	"./template.buffalobet": 1588,
	"./template.buffalobet.tsx": 1588,
	"./template.chromabet": 1589,
	"./template.chromabet.tsx": 1589,
	"./template.default": 91,
	"./template.default.tsx": 91,
	"./template.epicodds": 1590,
	"./template.epicodds.tsx": 1590,
	"./template.fiestabet": 1591,
	"./template.fiestabet.tsx": 1591,
	"./template.forsport": 1592,
	"./template.forsport.tsx": 1592,
	"./template.gigabet": 1593,
	"./template.gigabet.tsx": 1593,
	"./template.goldenbet888": 1594,
	"./template.goldenbet888.tsx": 1594,
	"./template.goldenrush": 1595,
	"./template.goldenrush.tsx": 1595,
	"./template.hyperbet": 1596,
	"./template.hyperbet.tsx": 1596,
	"./template.juicybet": 1597,
	"./template.juicybet.tsx": 1597,
	"./template.junglebet": 1598,
	"./template.junglebet.tsx": 1598,
	"./template.magnumbet": 1599,
	"./template.magnumbet.tsx": 1599,
	"./template.oldgill": 1600,
	"./template.oldgill.tsx": 1600,
	"./template.puntcity": 1601,
	"./template.puntcity.tsx": 1601,
	"./template.puntgenie": 1602,
	"./template.puntgenie.tsx": 1602,
	"./template.pyramidbet": 1603,
	"./template.pyramidbet.tsx": 1603,
	"./template.questbet": 1604,
	"./template.questbet.tsx": 1604,
	"./template.slambet": 1605,
	"./template.slambet.tsx": 1605,
	"./template.sterlingparker": 1606,
	"./template.sterlingparker.tsx": 1606,
	"./template.sugarcastle": 1607,
	"./template.sugarcastle.tsx": 1607,
	"./template.templebet": 1608,
	"./template.templebet.tsx": 1608,
	"./template.titanbet": 1609,
	"./template.titanbet.tsx": 1609,
	"./template.ts": 984,
	"./template.vikingbet": 1610,
	"./template.vikingbet.tsx": 1610,
	"./template.volcanobet": 1611,
	"./template.volcanobet.tsx": 1611,
	"./template.wellbet": 1612,
	"./template.wellbet.tsx": 1612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2452;